import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const BasedOnMedicareEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!contract) return;

    const isChecked = event.target.checked;
    
    // If unchecking, reset all Medicare fields to default values
    if (!isChecked) {
      dispatch(updateSelectedContract({
        medicareBasedConfig: {
          basedOnMedicare: false,
          percentOfMedicare: 0,
          percentOfMedicareIP: 0,
          percentOfMedicareOP: 0,
          inpatientConversionFactor: 0,
          outpatientConversionFactor: 0,
          medicareContractId: 'N/A'
        }
      }));
    } else {
      dispatch(updateSelectedContract({
        medicareBasedConfig: {
          ...contract.medicareBasedConfig,
          basedOnMedicare: true
        }
      }));
    }
  };

  if (!contract) return null;

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={contract.medicareBasedConfig?.basedOnMedicare ?? false}
          onChange={handleChange}
          color="primary"
        />
      }
      label="Based on Medicare"
    />
  );
};

export default BasedOnMedicareEditor;